import { createSelector } from "reselect";
import { UserRole } from "../../../@types/userRole";
import { RootState } from "../../rootReducer";

export const selectUserRoles = createSelector(
  [
    (store: RootState) => store.supervisorHome.userRoles,
    (store: RootState) => store.supervisorHome.userRolesSearchText,
  ],
  (data, searchText) =>
    [...(data || [])]
      .filter(({ searchTextUser }) => searchTextUser?.toLowerCase().includes(searchText.toLowerCase()))
      .reduce((list: UserRole[], item) => {
        if (!list.some(({ user }) => user.id === item.user.id)) {
          list.push(item);
        }
        return list;
      }, [])
      .sort((a, b) => {
        if ((a.user?.name || "") > (b.user?.name || "")) {
          return 1;
        }
        return -1;
      })
);
